import { BadgeCheck, ImageUp, PenTool, Truck, Wine, type LucideIcon } from "lucide-react"

// Duncan's five steps (PRD F2), shared by the home-page teaser and the
// How It Works page so the two never drift apart.
export type HowItWorksStep = {
  title: string
  teaser: string
  icon: LucideIcon
  detail: string[]
  note?: string
}

export const HOW_IT_WORKS_STEPS: HowItWorksStep[] = [
  {
    title: "Choose your wines",
    teaser: "Red, white, rosé or MCC, chosen to suit your budget.",
    icon: Wine,
    detail: [
      "Start with the budget you have in mind, then the style: red, white, rosé or MCC, South Africa's traditional-method sparkling wine.",
      "Mix them freely. Your order begins at 100 bottles, made up however you like.",
    ],
    note: "From 100 bottles, mixed as you like",
  },
  {
    title: "Share your logo or idea",
    teaser: "A logo, a crest, a photograph — or simply an idea.",
    icon: ImageUp,
    detail: [
      "Send us your logo, a crest, a photograph, or simply tell us about the occasion. Names, dates and a line of your own are all welcome.",
      "If you have nothing yet, that is perfectly fine. We will shape it with you.",
    ],
  },
  {
    title: "We design your label",
    teaser: "Finished to production standard by our design team.",
    icon: PenTool,
    detail: [
      "Our designers work your artwork into a label that sits properly on the bottle, and it is printed by Lebone Paarl Labels, winners at the FINAT 2024 awards.",
    ],
  },
  {
    title: "You approve",
    teaser: "Nothing is printed until you are entirely happy.",
    icon: BadgeCheck,
    detail: [
      "You see a proof of your label before anything goes to print. Ask for changes until it is exactly right.",
    ],
    note: "Approval before print, always",
  },
  {
    title: "Delivered to your door",
    teaser: "To your venue, office or home, anywhere in the UK.",
    icon: Truck,
    detail: [
      "Your bottles arrive labelled and ready: at your venue, your office or your home, anywhere in the United Kingdom.",
    ],
    note: "Delivered throughout the UK",
  },
]
